var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BgdAccountsUtils from '@background/utils/accounts.utils';
import { FavoriteUserListName, } from '@interfaces/favorite-user.interface';
import { exchanges } from '@popup/steem/pages/app-container/home/buy-coins/buy-coins-list-item.list';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const getAutocompleteList = (username, localAccounts, options) => __awaiter(void 0, void 0, void 0, function* () {
    const favoriteUsers = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.FAVORITE_USERS);
    const autoCompleteList = [];
    if (favoriteUsers && favoriteUsers[username]) {
        for (const fav of favoriteUsers[username]) {
            if (!exchanges.find((exchange) => exchange.username === fav) &&
                !localAccounts.find((localAccount) => localAccount.name === fav))
                autoCompleteList.push({ value: fav });
        }
    }
    for (const localAccount of localAccounts) {
        if (localAccount.name !== username) {
            autoCompleteList.push({
                value: localAccount.name,
            });
        }
    }
    if (options === null || options === void 0 ? void 0 : options.addExchanges)
        for (const exchange of exchanges) {
            if ((((options === null || options === void 0 ? void 0 : options.token) && exchange.acceptedCoins.includes(options.token)) ||
                !(options === null || options === void 0 ? void 0 : options.token)) &&
                exchange.username.length > 0)
                autoCompleteList.push({
                    value: exchange.username,
                    subLabel: exchange.name,
                });
        }
    return autoCompleteList;
});
const saveFavoriteUser = (username, activeAccount) => __awaiter(void 0, void 0, void 0, function* () {
    const mk = yield LocalStorageUtils.getValueFromSessionStorage(LocalStorageKeyEnum.__MK);
    const localAccounts = yield BgdAccountsUtils.getAccountsFromLocalStorage(mk);
    let favoriteUser = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.FAVORITE_USERS);
    if (!favoriteUser) {
        favoriteUser = { [activeAccount.name]: [] };
    }
    if (!favoriteUser[activeAccount.name]) {
        favoriteUser[activeAccount.name] = [];
    }
    let found = false;
    if (favoriteUser[activeAccount.name].length > 0) {
        found = Object.values(favoriteUser[activeAccount.name]).some((favValue) => favValue.value === username);
    }
    if (!found &&
        !exchanges.find((exchange) => exchange.username === username) &&
        !localAccounts.find((localAccount) => localAccount.name === username)) {
        favoriteUser[activeAccount.name].push({
            value: username,
            subLabel: '',
        });
    }
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.FAVORITE_USERS, favoriteUser);
});
const getAutocompleteListByCategories = (username, localAccounts, options) => __awaiter(void 0, void 0, void 0, function* () {
    const favoriteUsers = yield fixFavoriteList(yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.FAVORITE_USERS));
    const favoriteUsersList = {
        title: FavoriteUserListName.USERS,
        translateTitle: true,
        values: [],
    };
    const favoriteLocalAccountsList = {
        title: FavoriteUserListName.LOCAL_ACCOUNTS,
        translateTitle: true,
        values: [],
    };
    const favoriteExchangesList = {
        title: FavoriteUserListName.EXCHANGES,
        translateTitle: true,
        values: [],
    };
    const favoriteUsersCompleteList = {
        categories: [],
    };
    if (favoriteUsers && favoriteUsers[username]) {
        for (const fav of favoriteUsers[username]) {
            if (!exchanges.find((exchange) => exchange.username === fav) &&
                !localAccounts.find((localAccount) => localAccount.name === fav))
                favoriteUsersList.values.push(fav);
        }
    }
    for (const localAccount of localAccounts) {
        if (localAccount.name !== username) {
            favoriteLocalAccountsList.values.push({
                value: localAccount.name,
                subLabel: '',
            });
        }
    }
    if (options === null || options === void 0 ? void 0 : options.addExchanges)
        for (const exchange of exchanges) {
            if ((((options === null || options === void 0 ? void 0 : options.token) && exchange.acceptedCoins.includes(options.token)) ||
                !(options === null || options === void 0 ? void 0 : options.token)) &&
                exchange.username.length > 0)
                favoriteExchangesList.values.push({
                    value: exchange.username,
                    subLabel: exchange.name,
                });
        }
    if (favoriteUsersList.values.length > 0) {
        favoriteUsersCompleteList.categories.push(favoriteUsersList);
    }
    if (favoriteLocalAccountsList.values.length > 0) {
        favoriteUsersCompleteList.categories.push(favoriteLocalAccountsList);
    }
    if (favoriteExchangesList.values.length > 0) {
        favoriteUsersCompleteList.categories.push(favoriteExchangesList);
    }
    return favoriteUsersCompleteList;
});
const fixFavoriteList = (favoriteUsers) => __awaiter(void 0, void 0, void 0, function* () {
    let hasChanged = false;
    if (typeof favoriteUsers === 'string') {
        favoriteUsers = JSON.parse(favoriteUsers);
    }
    for (const user in favoriteUsers) {
        if (!Array.isArray(favoriteUsers[user]))
            favoriteUsers[user] = [];
        favoriteUsers[user] = favoriteUsers[user].map((e) => {
            if (typeof e === 'string') {
                hasChanged = true;
                return { label: e, value: e };
            }
            else
                return e;
        });
    }
    if (hasChanged) {
        yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.FAVORITE_USERS, favoriteUsers);
    }
    return favoriteUsers;
});
export const FavoriteUserUtils = {
    getAutocompleteList,
    saveFavoriteUser,
    getAutocompleteListByCategories,
    fixFavoriteList,
};
